export default __webpack_public_path__ + "static/media/asia_achievement.eb5d0594.png";